var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5321_207064)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5321_207064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 4.99951L17.001 8.06151C18.7632 8.2843 20.4013 9.08694 21.6572 10.343C22.9131 11.5991 23.7155 13.2373 23.938 14.9995H27V16.9995L23.938 17.0005C23.7153 18.7626 22.9128 20.4005 21.6569 21.6564C20.401 22.9123 18.7631 23.7148 17.001 23.9375L17 26.9995H15V23.9375C13.2378 23.715 11.5996 22.9126 10.3435 21.6567C9.08743 20.4008 8.28479 18.7627 8.062 17.0005L5 16.9995V14.9995H8.062C8.28459 13.2371 9.08713 11.5988 10.3432 10.3427C11.5993 9.08665 13.2376 8.2841 15 8.06151V4.99951H17ZM16 9.99951C14.4087 9.99951 12.8826 10.6317 11.7574 11.7569C10.6321 12.8821 10 14.4082 10 15.9995C10 17.5908 10.6321 19.1169 11.7574 20.2422C12.8826 21.3674 14.4087 21.9995 16 21.9995C17.5913 21.9995 19.1174 21.3674 20.2426 20.2422C21.3679 19.1169 22 17.5908 22 15.9995C22 14.4082 21.3679 12.8821 20.2426 11.7569C19.1174 10.6317 17.5913 9.99951 16 9.99951ZM16 13.9995C16.5304 13.9995 17.0391 14.2102 17.4142 14.5853C17.7893 14.9604 18 15.4691 18 15.9995C18 16.5299 17.7893 17.0387 17.4142 17.4137C17.0391 17.7888 16.5304 17.9995 16 17.9995C15.4696 17.9995 14.9609 17.7888 14.5858 17.4137C14.2107 17.0387 14 16.5299 14 15.9995C14 15.4691 14.2107 14.9604 14.5858 14.5853C14.9609 14.2102 15.4696 13.9995 16 13.9995Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5321_207064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5321_207064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 3.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterIcon);
export default __webpack_public_path__ + "static/media/center_icon.d928b0aa11acaa393e7bab26aa62b528.svg";
export { ForwardRef as ReactComponent };